import { ThemeProvider } from '@material-ui/core'
import materialTheme from 'common/material'
/* import ErrorInterceptor from 'components/errorInterceptor/ErrorInterceptor' */
import { createRoot } from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import { BrowserRouter } from 'react-router-dom'
import { StrictMode } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { DataProvider } from 'context/DataContext'
import App from './App'
import i18n from './common/i18n'
import './index.scss'
import reportWebVitals from './reportWebVitals'

const container = document.getElementById('root')

if (!container) {
    throw new Error('Root container not found')
}

const root = createRoot(container)
const queryClient = new QueryClient()

root.render(
    <StrictMode>
        <DataProvider>
            <BrowserRouter>
                <I18nextProvider i18n={i18n}>
                    <ThemeProvider theme={materialTheme}>
                        <QueryClientProvider client={queryClient}>
                            <App />
                        </QueryClientProvider>
                    </ThemeProvider>
                </I18nextProvider>
            </BrowserRouter>
        </DataProvider>
    </StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
